/* iPhone XR, 12 Pro, 14 Pro Max, Pixel 7: hacer la foto más grande */
@media (max-width: 432px) and (min-width: 390px), /* iPhone 14 Pro Max */
       (max-width: 393px) and (min-width: 390px), /* Pixel 7 */
       (max-width: 414px) and (min-width: 390px)  /* iPhone XR, 12 Pro */ {
  .hero__nurse img {
    width: min(2000px, 600vw) !important;
  }
}
<template>
  <!-- HERO full width (fondo ocupa toda la sección) -->
  <section class="hero">
    <div class="hero__inner">
      <!-- Texto -->
      <div class="hero__copy">
        <h1 class="hero__title">
          PEQUEÑOS HÉROES<br />
          SIEMPRE PROTEGIDOS
        </h1>

        <p class="hero__subtitle">
          Tecnología inteligente que los cuida<br />
          mientras descubren el mundo.
        </p>
      </div>

      <!-- Estrellas decorativas -->
      <img class="star star--big" src="../assets/IMG/Estrella.png" alt="Estrella grande" />
      <img class="star star--small" src="../assets/IMG/Estrella.png" alt="Estrella pequeña" />

      <!-- Imagen de enfermero a la derecha -->
      <div class="hero__nurse">
        <img src="../assets/IMG/Enfermero.png" alt="Enfermero" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "WelcomeView",
};
</script>

<style scoped>
@font-face {
  font-family: "Cocomat Pro";
  src: url("../assets/fonts/CocomatPro-Regular.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: "Cocomat Pro";
  src: url("../assets/fonts/CocomatPro-Bold.ttf") format("truetype");
  font-weight: 700;
  font-style: normal;
}

/* ====== HERO BASE DESKTOP ====== */
.hero {
  position: relative;
  width: 100vw;
  left: 50%;
  margin-left: -50vw;
  margin-top: 86px;
  min-height: clamp(580px, 62vw, 860px);
  overflow: hidden;

  background-color: #001e46;
  background-image: url("../assets/IMG/fondo2.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 82.1% auto;

  padding-left: 8vw;
  padding-right: 8vw;
}

.hero__inner {
  position: relative;
  min-height: inherit;
  height: 100%;
  width: 100%;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: clamp(22px, 3.2vw, 54px) clamp(10px, 2.8vw, 38px);
}

/* ====== TEXTO ====== */
.hero__copy {
  width: min(900px, 80%);
  margin-left: clamp(28px, 4.5vw, 76px);
  transform: translateY(-80px);
  z-index: 4;
  text-align: left;
}

.hero__title {
  margin: 0;
  color: #ebcfaf;
  font-family: "Cocomat Pro", Arial, sans-serif;
  font-size: clamp(38px, 4.7vw, 62px);
  font-weight: 700;
  line-height: 1.05;
  letter-spacing: 0.01em;
  text-transform: uppercase;
}

.hero__subtitle {
  margin: 18px 0 0;
  color: #f6e7d3;
  font-family: "Cocomat Pro", Arial, sans-serif;
  font-size: clamp(20px, 1.9vw, 32px);
  font-weight: 400;
  line-height: 1.22;
  max-width: 560px;
}

/* ====== IMAGEN ====== */
.hero__nurse {
  position: absolute;
  right: 1.2vw;
  bottom: -12.37vw;
  top: auto;
  display: flex;
  align-items: flex-end;
  z-index: 2;
}

.hero__nurse img {
  width: 1400px;
  height: 1400px;
  max-width: 140vw;
  max-height: 140vh;
  object-fit: contain;
  transform: none;
}

/* ====== ESTRELLAS ====== */
.star {
  position: absolute;
  z-index: 3;
  pointer-events: none;
  user-select: none;
}

.star--big {
  left: 38%;
  top: 51%;
  width: 180px;
  height: auto;
  transform: rotate(330deg);
  opacity: 0.92;
}

.star--small {
  left: 33%;
  top: 60%;
  width: 75px;
  height: auto;
  transform: rotate(330deg);
  opacity: 0.92;
}

/* ====== DESKTOP MEDIO ====== */
@media (max-width: 1400px) {
  .hero__copy {
    width: min(720px, 56%);
    transform: translateY(-55px);
  }

  .hero__nurse {
    right: -1vw;
    bottom: -11vw;
  }

  .hero__nurse img {
    width: 1180px;
    height: 1180px;
  }

  .star--big {
    left: 39%;
    top: 52%;
    width: 150px;
  }

  .star--small {
    left: 34%;
    top: 60%;
    width: 62px;
  }
}

@media (max-width: 1200px) {
  .hero {
    min-height: clamp(540px, 64vw, 780px);
    background-size: 90% auto;
  }

  .hero__copy {
    width: min(620px, 54%);
    margin-left: 16px;
    transform: translateY(-20px);
  }

  .hero__title {
    font-size: clamp(34px, 4.4vw, 54px);
  }

  .hero__subtitle {
    font-size: clamp(18px, 1.8vw, 26px);
    max-width: 470px;
  }

  .hero__nurse {
    right: -3vw;
    bottom: -9vw;
  }

  .hero__nurse img {
    width: 980px;
    height: 980px;
  }

  .star--big {
    left: 40%;
    top: 54%;
    width: 126px;
  }

  .star--small {
    left: 35.5%;
    top: 62%;
    width: 54px;
  }
}

/* ====== TABLETS: DOS COLUMNAS ====== */
@media (min-width: 768px) and (max-width: 1024px) {
  .hero {
    margin-top: 78px;
    min-height: 720px;
    padding-left: 3.5vw;
    padding-right: 3.5vw;
    background-color: #001e46;
    background-image: url("../assets/IMG/fondo2.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 108% auto;
  }

  .hero__inner {
    min-height: inherit;
    padding: 30px 14px 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .hero__copy {
    width: 50%;
    margin-left: 8px;
    transform: translateY(-48px) !important;
    text-align: left;
    z-index: 4;
  }

  .hero__title {
    font-size: clamp(34px, 4.5vw, 52px);
    line-height: 1.02;
    letter-spacing: 0.01em;
  }

  .hero__subtitle {
    margin-top: 12px;
    max-width: 360px;
    font-size: clamp(16px, 2vw, 22px);
    line-height: 1.18;
  }

  .hero__nurse {
    position: absolute;
    right: -10vw;
    bottom: -18vw;
    left: auto;
    top: auto;
    z-index: 2;
    transform: none;
    width: auto;
    justify-content: flex-end;
  }

  .hero__nurse img {
    width: 1100px;
    height: 1100px;
    max-width: none;
    max-height: none;
    object-fit: contain;
  }

  /* ocultar estrellas en tablets/iPad */
  .star {
    display: none !important;
  }
}

/* iPad mini vertical aprox */
@media (min-width: 768px) and (max-width: 834px) {
  .hero {
    min-height: 690px;
    background-size: 118% auto;
  }

  .hero__copy {
    width: 50%;
    transform: translateY(-92px) !important;
  }

  .hero__title {
    font-size: clamp(30px, 4.6vw, 44px);
  }

  .hero__subtitle {
    font-size: clamp(15px, 2vw, 20px);
    max-width: 320px;
  }

  .hero__nurse {
    right: -18vw;
    bottom: -22vw;
  }

  .hero__nurse img {
    width: 1080px;
    height: 1080px;
  }
}

/* iPad Air / 10.9 / tablets medianas */
@media (min-width: 835px) and (max-width: 980px) {
  .hero {
    min-height: 730px;
    background-size: 112% auto;
  }

  .hero__copy {
    width: 50%;
    transform: translateY(-58px) !important;
  }

  .hero__title {
    font-size: clamp(34px, 4.2vw, 48px);
  }

  .hero__subtitle {
    max-width: 345px;
  }

  .hero__nurse {
    right: -14vw;
    bottom: -18vw;
  }

  .hero__nurse img {
    width: 1120px;
    height: 1120px;
  }
}

/* iPad Pro 11 y similares */
@media (min-width: 981px) and (max-width: 1024px) {
  .hero {
    min-height: 760px;
    background-size: 104% auto;
  }

  .hero__copy {
    width: 48%;
    transform: translateY(-44px) !important;
  }

  .hero__title {
    font-size: clamp(33px, 3.7vw, 47px);
  }

  .hero__subtitle {
    max-width: 360px;
    font-size: clamp(16px, 1.7vw, 20px);
  }

  .hero__nurse {
    right: -11vw;
    bottom: -17vw;
  }

  .hero__nurse img {
    width: 1160px;
    height: 1160px;
  }
}

/* iPad Pro 12.9 vertical */
@media (width: 1024px) and (height: 1366px) {
  .hero {
    margin-top: 86px;
    min-height: 860px;
    padding-left: 5vw;
    padding-right: 5vw;
    background-size: 100% auto;
    background-position: center;
  }

  .hero__inner {
    padding: 28px 12px;
  }

  .hero__copy {
    width: 47%;
    margin-left: 8px;
    transform: translateY(-54px) !important;
    text-align: left;
  }

  .hero__title {
    font-size: 49px;
    line-height: 1.02;
  }

  .hero__subtitle {
    margin: 16px 0 0;
    font-size: 18.5px;
    line-height: 1.18;
    max-width: 390px;
  }

  .hero__nurse {
    right: -10vw;
    bottom: -16vw;
  }

  .hero__nurse img {
    width: 1220px !important;
    height: 1220px !important;
    max-width: none !important;
    max-height: none !important;
  }

  .star {
    display: none !important;
  }
}
/* ====== MÓVILES ====== */
@media (max-width: 767px) {
  .hero {
    min-height: 84svh;
    height: 84svh;
    margin-top: 72px;
    padding-left: 0;
    padding-right: 0;
    background-color: #001e46;
    background-image: url("../assets/IMG/fondo.png");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center bottom;
  }

  .hero__inner {
    position: relative;
    height: 100%;
    min-height: 0;
    padding: 16px 16px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
  }

  .hero__copy {
    width: min(560px, 92%);
    margin: 0 auto;
    transform: translateY(26px) !important;
    text-align: center;
    z-index: 4;
  }

  .hero__title {
    font-family: "Cocomat Pro", Arial, sans-serif;
    font-weight: 700;
    line-height: 1.02;
    text-transform: uppercase;
    letter-spacing: 0.01em;
    font-size: clamp(28px, 7.3vw, 42px);
  }

  .hero__subtitle {
    margin: 10px auto 0;
    font-family: "Cocomat Pro", Arial, sans-serif;
    font-weight: 400;
    line-height: 1.18;
    font-size: clamp(15px, 4.2vw, 21px);
    max-width: 24ch;
  }

  .hero__nurse {
    position: absolute;
    right: 0;
    left: auto;
    bottom: -4%;
    transform: none;
    top: auto;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    z-index: 10;
    pointer-events: none;
  }

  .hero__nurse img {
    width: min(1850px, 520vw);
    height: auto;
    max-width: none;
    max-height: none;
    object-fit: contain;
  }

  .star {
    display: none !important;
  }
}

/* Móviles grandes: iPhone XR, 12 Pro, 14 Pro Max, Pixel 7 */
@media (min-width: 391px) and (max-width: 480px) {
  .hero__copy {
    transform: translateY(34px) !important;
  }

  .hero__title {
    font-size: clamp(27px, 7.2vw, 40px);
    line-height: 1.01;
  }

  .hero__subtitle {
    margin-top: 10px;
    font-size: clamp(14px, 4.1vw, 19px);
    max-width: 25ch;
  }

  .hero__nurse {
    bottom: -4%;
  }

  .hero__nurse img {
    width: min(1700px, 500vw);
  }

  .star {
    display: none !important;
  }
}

/* Móviles pequeños generales */
@media (max-width: 390px) {
  .hero {
    min-height: 88svh;
    height: 88svh;
  }

  .hero__copy {
    transform: translateY(34px) !important;
  }

  .hero__title {
    font-size: clamp(24px, 8.2vw, 34px);
  }

  .hero__subtitle {
    font-size: clamp(13px, 4.3vw, 17px);
    max-width: 24ch;
  }

  .hero__nurse {
    bottom: -3%;
  }

  .hero__nurse img {
    width: min(1280px, 390vw);
  }

  .star {
    display: none !important;
  }
}

/* EXCEPCIÓN: iPhone SE 375 x 667 */
@media (width: 375px) and (height: 667px) {
  .hero__copy {
    transform: translateY(10px) !important;
  }

  .hero__title {
    font-size: 31px;
    line-height: 1.02;
  }

  .hero__subtitle {
    font-size: 15px;
    max-width: 24ch;
  }

  .hero__nurse {
    bottom: -1%;
  }

  .hero__nurse img {
    width: min(980px, 300vw);
  }

  .star {
    display: none !important;
  }
}
/* Solo iPhone 14 Pro Max */
@media (width: 430px) and (height: 932px) {
  .hero {
    min-height: 80svh;
    height: 80svh;
    background-position: center 522px; /* sube un poco el fondo */
    background-size: 100% auto;
  }

  .hero__copy {
    transform: translateY(22px) !important;
  }

  .hero__title {
    font-size: 35px;
  }

  .hero__subtitle {
    font-size: 16px;
  }

  .hero__nurse {
    bottom: 1.5%; /* sube la foto */
    right: 0;
  }

  .hero__nurse img {
    width: min(1750px, 510vw);
  }
}
@media (width: 412px) and (height: 915px) {
  .hero {
    min-height: 80svh;
    height: 80svh;
    background-position: center 518px;
    background-size: 100% auto;
  }

  .hero__copy {
    transform: translateY(22px) !important;
  }

  .hero__title {
    font-size: 35px;
  }

  .hero__subtitle {
    font-size: 16px;
  }

  .hero__nurse {
    bottom: 1.5%;
    right: 0;
  }

  .hero__nurse img {
    width: min(1750px, 510vw);
  }
}
@media (width: 390px) and (height: 844px) {
  .hero {
    min-height: 80svh;
    height: 80svh;
    background-position: center 472px;
    background-size: 100% auto;
  }

  .hero__copy {
    transform: translateY(22px) !important;
  }

  .hero__title {
    font-size: 35px;
  }

  .hero__subtitle {
    font-size: 16px;
  }

  .hero__nurse {
    bottom: 1.5%;
    right: 0;
  }

  .hero__nurse img {
    width: min(1750px, 510vw);
  }
}
</style>